import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { ActivityReply } from "../../../../@types/activities.ts";
import { MouseEvent } from "react";
import classNames from "classnames";
import TranslationIndicator from "../../../shared/TranslationIndicator.tsx";

// the leading space only survives in a flex item with whitespace-pre
function externalBadge(isExternal?: boolean) {
  return isExternal ? ` (${I18n.t("js.external_member.badge")})` : "";
}

export default function ReplyQuote({
  author,
  content,
  handleCancelQuote,
  className,
  translated,
}: ActivityReply["quote_data"] & {
  handleCancelQuote?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  translated?: boolean;
}) {
  return (
    <div
      className={classNames(
        "quote_block pl-2 border-l-4 border-primary bg-gray-50 py-1 rounded-md mb-4 relative",
        className,
      )}
    >
      <div className="flex justify-between items-start">
        {/* a long name is cut short, the full one comes on hover; the badge
            stays readable, and the name keeps clear of the cancel button */}
        {author && (
          <a
            href={author.url}
            className={classNames(
              "font-semibold member-link member-name mb-1 flex min-w-0",
              { "pr-6": handleCancelQuote },
            )}
            title={`${author.displayName}${externalBadge(author.is_external)}`}
          >
            <span className="truncate">{author.displayName}</span>
            {author.is_external && (
              <span className="shrink-0 whitespace-pre">
                {externalBadge(author.is_external)}
              </span>
            )}
          </a>
        )}
        {handleCancelQuote && (
          <div className="cancel-quote btn btn-sm text-muted absolute top-2 right-2">
            <button
              className="btn btn-sm p-0"
              onClick={handleCancelQuote}
              title={I18n.t("js.cancel")}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        )}
      </div>
      {/* the quoted HTML has no prose styles, so long links and code blocks
          need their own hold to stay inside the quote (tixxt/core#712) */}
      <div
        className="text-gray-600 mt-1 break-words [&_pre]:overflow-x-auto"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {translated && <TranslationIndicator />}
    </div>
  );
}
